import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  setPropertyWalkThroughFormStep,
  setPropertyWalkThroughFormData,
  fetchConfigureTypeWalkThroughData,
  exitPropertyWalkThroughForm,
} from '../../../store/actions/propertyWalkThroughForm';
import { selectPropertyWalkThroughFormData } from '../../../store/selectors/propertyWalkThroughForm';
import {
  setEasyWalkThroughFormData,
  setEasyWalkThroughFormNextStep,
  fetchWalkThroughServiceList,
  exitEasyWalkThroughForm,
} from '../../../store/actions/easyWalkThroughForm';
import { selectSuiteById } from '../../../store/selectors/suites';
import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import Col from '../../Col';
import FontAwesomeIcon from '../../Icon';
import '../../../layouts/WithNavigation/Sidebar.scss';
import './OfflineWalkthroughData.scss';
import '../../Heading/Heading.scss';
import '../../Documents/Documents.scss';
import './LeftNavigation.scss';
import {
  fetchAreasAndSubAreas,
  fetchAreaData,
  fetchSuiteCheckList,
} from '../../../store/actions/areas';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Loader from '../../Loader';
import 'react-image-lightbox/style.css';
import Button from '../../Button';
import { convertImgToBase64 } from '../IndexDB';
import CreatableSelect from 'react-select/creatable';
import Overlay from '../../Overlay';
import { setWalkThroughStatus } from '../../../store/actions/suites';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { selectWalkThrough } from '../../../store/selectors/walkThrough';
import { selectEasyWalkThroughFormData } from '../../../store/selectors/easyWalkThroughForm';
import ReviewTable1 from '../../ReviewTable/ReviewTable1';
import {
  saveServiceRequest,
  updateServiceRequest,
} from '../../../store/actions/serviceRequest';
import { deleteServiceRequest } from '../../../store/actions/serviceRequests';
import Marker from '../../AnnotateImage/Marker';
import SignatureCanvas from '../../SignatureCanvas';
import Row from '../../Row';
import Input from '../../Input';
import { selectFormLoader } from '../../../store/selectors/FormLoader';
import Textarea from '../../Textarea';
import CompleteDeveloperWalkThrough from './CompleteDeveloperWalkThrough';
import CreateDeveloperServiceRequest from './CreateDeveloperServiceRequest';
import './SimplifiedMobileWalkThrough.scss';
import classNames from 'classnames';
import CustomSelect from './CustomSelect';
import File from '../../File';
import Avatar from '../../Avatar';
import * as client from '../../../services/client';
import {
  startFormLoading,
  stopFormLoading,
} from '../../../store/actions/loader';
import {
  fetchAllTicketStatus,
  fetchServiceRequestTags,
} from '../../../store/actions/formOptions';
import { upload } from '../../../helpers/upLoadHelper';
import { onCheckDocument } from '../../../helpers/CommonHelpers';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';

class DeveloperWalkthrough extends Component {
  state = {
    firstName: '',
    lastName: '',
    role: '',
    email: '',
    showOverlay: false,
    showAddForm: false,
    isOpen: false,
    selectedIndex: null,
    open: false,
    floorPlanURL: '',
    walkThroughSignatureList: [],
    itemImage: [],
    subAreas: [],
    reviewAndSignIn: false,
    selectedImages: [],
    showImages: false,
    editInprogress: false,
    subAreasByLocation: [],
    locations: [],
  };

  async componentDidMount() {
    const {
      propertyWalkThroughFormData,
      onFetchConfigureTypeWalkThroughData,
      onFetchAreasAndSubAreas,
      onFetchWalkThroughServiceList,
      onSetEasyWalkThroughFormData,
      onFetchServiceRequestTags,
    } = this.props;
    onSetEasyWalkThroughFormData({ walkThroughServiceRequests: [] });
    onFetchConfigureTypeWalkThroughData(
      propertyWalkThroughFormData.walkthroughId
    );
    onFetchAreasAndSubAreas(propertyWalkThroughFormData.walkthroughId);
    onFetchWalkThroughServiceList(propertyWalkThroughFormData.walkthroughId);
    this.handleSignatures();
    this.props.onFetchTicketStatus();
    this.getLocations(propertyWalkThroughFormData.walkthroughId);
    this.setDefaultIssueType();
    onFetchServiceRequestTags();
  }

  setDefaultIssueType = () => {
    const { types, onSetEasyWalkThroughFormData } = this.props;
    let issue = types.filter((item) => item.name === 'General')[0];
    if (issue && issue.id) {
      onSetEasyWalkThroughFormData({
        issueType: issue.name,
        issueTypeId: issue.id,
      });
    }
  };

  getLocations(id) {
    this.props.startFormLoading();
    client
      .getLocationsById(id)
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            this.setState({
              locations: responsejson.data,
            });
            this.props.stopFormLoading();
          });
        } else {
          this.props.stopFormLoading();
        }
      })
      .catch((e) => this.props.stopFormLoading());
  }

  handleSignatures = () => {
    const { easyWalkThroughFormData, propertyWalkThroughFormData } = this.props;
    const {
      homeOwnerFirstName,
      homeOwnerLastName,
      propertyManagerFirstName,
      propertyManagerLastName,
    } = easyWalkThroughFormData;

    let mandatorySigns = [];
    if (propertyWalkThroughFormData.status === 'In Progress Home Only') {
      mandatorySigns = [
        {
          email: null,
          firstName: homeOwnerFirstName,
          lastName: homeOwnerLastName,
          role: 'Home Owner',
          signType: '',
          signature: '',
        },
      ];
    } else {
      if (
        propertyWalkThroughFormData.walkthroughType ===
          'Home Owner Walk-through' &&
        propertyWalkThroughFormData.isHomeOwner === true
      ) {
        mandatorySigns = [
          {
            email: null,
            firstName: propertyManagerFirstName,
            lastName: propertyManagerLastName,
            role: 'Property Developer',
            signType: '',
            signature: '',
          },
          {
            email: null,
            firstName: homeOwnerFirstName,
            lastName: homeOwnerLastName,
            role: 'Home Owner',
            signType: '',
            signature: '',
          },
        ];
      } else {
        mandatorySigns = [
          {
            email: null,
            firstName: propertyManagerFirstName,
            lastName: propertyManagerLastName,
            role: 'Property Developer',
            signType: '',
            signature: '',
          },
        ];
      }
    }
    this.setState({ walkThroughSignatureList: mandatorySigns });
  };

  handleSubmit() {
    const { walkThroughSignatureList } = this.state;
    this.handleCompleteWalkThrough(walkThroughSignatureList);
  }

  handleCompleteWalkThrough = (signatures) => {
    const {
      setWalkThroughStatus,
      propertyWalkThroughFormData,
      onExitPropertyWalkThroughForm,
      user,
      easyWalkThroughFormData,
    } = this.props;
    let status = {
      WalkthroughId: propertyWalkThroughFormData.walkthroughId,
      PropertyId: propertyWalkThroughFormData.propertyId,
      SuiteId: propertyWalkThroughFormData.suiteId,
      UserId: user.id,
      SignatureList: signatures,
      Status: 'Review',
      SuiteName: propertyWalkThroughFormData.suiteName,
      PropertyName: propertyWalkThroughFormData.propertyName,
      PropertymanagerId: propertyWalkThroughFormData.propertyManagerId,
      ActionUrl:
        'app/suites/' +
        propertyWalkThroughFormData.propertyId +
        '&' +
        propertyWalkThroughFormData.suiteId,
      Notes: easyWalkThroughFormData.notes ? easyWalkThroughFormData.notes : '',
    };

    setWalkThroughStatus(status);
    onExitPropertyWalkThroughForm();
  };

  onChange = (e) => {
    const { onSetEasyWalkThroughFormData } = this.props;
    const areas = this.state.locations;
    let filteredArea;
    filteredArea =
      areas && areas.length > 0
        ? areas.filter((area) => area.areaId === e.target.value)[0]
        : {};
    let area =
      filteredArea && filteredArea.customLabel
        ? filteredArea.customLabel
        : filteredArea.name;
    onSetEasyWalkThroughFormData({
      areaId: e.target.value,
      assetId: '',
      areaName: area,
      // subAreas: filteredArea && filteredArea.subAreas ? filteredArea.subAreas : []
    });
    this.onFetchAssetsByLocationId(e.target.value, areas[0].walkthroughId);
  };
  onFetchAssetsByLocationId = (value, walkthroughId) => {
    this.props.startFormLoading();
    client
      .getAssetsByLocationId(value, walkthroughId)
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            this.setState({
              subAreasByLocation: responsejson.data,
            });
            this.props.stopFormLoading();
          });
        } else {
          this.setState({
            subAreasByLocation: [],
          });
          this.props.stopFormLoading();
        }
      })
      .catch((e) => {
        this.setState({ subAreasByLocation: [] });
        this.props.stopFormLoading();
      });
  };
  onSelectIssueType = (e) => {
    const { types, onSetEasyWalkThroughFormData, user } = this.props;
    if (user.roles[0].role.name === 'Home Owner') {
      let issue = types.filter((item) => item.name === 'General')[0];
      const issueParams = {
        issueType: issue.name,
        issueTypeId: issue.id,
      };
      onSetEasyWalkThroughFormData(issueParams);
    } else {
      let issue = types.filter((item) => item.id === e.target.value)[0];
      onSetEasyWalkThroughFormData({
        issueType: issue.name,
        issueTypeId: issue.id,
      });
    }
  };
  onSelectImage = async (file) => {
    let theme = localStorage.getItem('theme');
    const { easyWalkThroughFormData, onSetEasyWalkThroughFormData } =
      this.props;
    let data;
    if (theme === 'Formwerks') {
      data = file;
    } else {
      data = await this.upLoadImage(file);
    }
    if (
      easyWalkThroughFormData &&
      easyWalkThroughFormData.selectedImage &&
      easyWalkThroughFormData.selectedImage.length > 0
    ) {
      if ([...easyWalkThroughFormData.selectedImage, ...data].length > 2) {
        window.alert('You can select only two images.');
      } else {
        onSetEasyWalkThroughFormData({
          selectedImage: [...easyWalkThroughFormData.selectedImage, ...data],
        });
        if (theme !== 'Formwerks') {
          this.setState({ showOverlay: true });
        }
      }
    } else {
      if (data.length > 2) {
        window.alert('You can select only two images.');
      } else {
        onSetEasyWalkThroughFormData({ selectedImage: data });
        if (theme !== 'Formwerks') {
          this.setState({ showOverlay: true });
        }
      }
    }
  };
  handleDelete = (item) => {
    const { easyWalkThroughFormData, onSetEasyWalkThroughFormData } =
      this.props;
    let images = easyWalkThroughFormData.selectedImage.filter(
      (data) => data !== item
    );
    onSetEasyWalkThroughFormData({ selectedImage: images });
  };
  upLoadImage = async (files) => {
    let upLoadedImages = [];
    if (files && files.length > 0) {
      for (var i = 0; i < files.length; i++) {
        let data = await convertImgToBase64(files[i]);
        upLoadedImages.push(data);
      }
      return upLoadedImages;
    }
  };
  onSaveImagesAnotated = (images) => {
    this.props.onSetEasyWalkThroughFormData({ selectedImage: images });
  };

  handleMultipleUpload = async (selectedImage, callback) => {
    let uploadImages = [];
    for (let i = 0; i < selectedImage.length; i++) {
      let imageObj = selectedImage[i];
      if (imageObj && imageObj.preview) {
        await this.uploadimg(imageObj, (imgData) => {
          uploadImages.push(imgData);
        });
      } else {
        uploadImages.push(imageObj);
      }
    }
    callback(uploadImages);
  };

  // function to upload the images into aws
  uploadimg = async (imgFile, callback) => {
    let imageUrl = await upload(imgFile);
    callback(imageUrl);
  };

  onCreateServiceRequest = async () => {
    const { subAreasByLocation } = this.state;
    const theme = localStorage.getItem('theme');
    const {
      easyWalkThroughFormData,
      propertyWalkThroughFormData,
      onSetEasyWalkThroughFormData,
      user,
      startFormLoading,
      onSaveServiceRequest,
    } = this.props;
    let serviceRequestTagging = [];
    let tags =
      easyWalkThroughFormData.tags && easyWalkThroughFormData.tags.length > 0
        ? easyWalkThroughFormData.tags
        : [];
    if (tags.length > 0) {
      Promise.all(
        tags.map((tag) => {
          if (tag.__isNew__) {
            serviceRequestTagging = [
              ...serviceRequestTagging,
              { name: tag.value },
            ];
          } else {
            serviceRequestTagging = [
              ...serviceRequestTagging,
              { id: tag.value },
            ];
          }
        })
      );
    }
    let asset = subAreasByLocation.filter(
      (s) => s.assetId === easyWalkThroughFormData.assetId
    )[0];
    let profileImage = easyWalkThroughFormData.selectedImage;
    let status = this.props.ticketStatus.filter(
      (item) => item.name == 'Submitted'
    );
    if (asset && asset.id) {
      let params = {
        IsServiceRequest: 'Walkthrough',
        WalkthroughId: propertyWalkThroughFormData.walkthroughId,
        property_id: propertyWalkThroughFormData.propertyId,
        propertyId: propertyWalkThroughFormData.propertyId,
        suite_id: propertyWalkThroughFormData.suiteId,
        suiteId: propertyWalkThroughFormData.suiteId,
        creatorId: user.id,
        assetId: easyWalkThroughFormData.assetId,
        itemId: asset.items && asset.items.id ? asset.items.id : asset.itemId,
        issueType: easyWalkThroughFormData.issueType,
        issueTypeId: easyWalkThroughFormData.issueTypeId,
        subject: 'Service Request',
        description: easyWalkThroughFormData.description,
        schedulePreferences:
          'Monday Mornings ( 8 AM - 11 AM ),Monday Afternoons ( 1 PM - 5 PM ),Monday Evenings ( 5 PM - 8 PM )',
        areaName: easyWalkThroughFormData.areaName,
        itemName: asset.name,
        area: { id: easyWalkThroughFormData.areaId },
        StatusName: 'Submitted',
        AssetName: asset.name,
        TicketStatusId: status[0].id,
        walkthroughType: propertyWalkThroughFormData.walkthroughType,
        walkthroughPermissions: propertyWalkThroughFormData.permissions
          ? propertyWalkThroughFormData.permissions
          : null,
        tags: serviceRequestTagging,
      };
      if (theme === 'Formwerks') {
        if (profileImage && profileImage.length > 0) {
          startFormLoading();
          let showUploadMessage = profileImage.filter(
            (img) => img && img.preview
          );
          if (showUploadMessage && showUploadMessage.length > 0) {
            toast.info('ⓘ  Please wait, while the file is being uploaded.', {
              autoClose: 4000,
              position: 'top-center',
            });
          }
          await this.handleMultipleUpload(profileImage, function (resObj) {
            params.profileImage = JSON.stringify(resObj).toString();
            params.Attachment = JSON.stringify(resObj).toString();
            onSaveServiceRequest(params, 'developerWalkthrough');
          });
        } else {
          params.profileImage = '';
          params.Attachment = '';
          onSaveServiceRequest(params, 'developerWalkthrough');
        }
      } else {
        params.profileImage =
          profileImage && profileImage.length > 0
            ? JSON.stringify(profileImage).toString()
            : '';
        params.Attachment =
          profileImage && profileImage.length > 0
            ? JSON.stringify(profileImage).toString()
            : '';
        onSaveServiceRequest(params, 'developerWalkthrough');
      }
      onSetEasyWalkThroughFormData({
        assetId: null,
        description: '',
        selectedImage: '',
        tags: [],
      });
      this.setDefaultIssueType();
    }
  };
  updateServiceRequest = async () => {
    let theme = localStorage.getItem('theme');
    const {
      onSetEasyWalkThroughFormData,
      easyWalkThroughFormData,
      user,
      onUpdateServiceRequest,
    } = this.props;
    let serviceRequestTagging = [];
    let tags =
      easyWalkThroughFormData.tags && easyWalkThroughFormData.tags.length > 0
        ? easyWalkThroughFormData.tags
        : [];
    if (tags.length > 0) {
      Promise.all(
        tags.map((tag) => {
          if (tag.__isNew__) {
            serviceRequestTagging = [
              ...serviceRequestTagging,
              { name: tag.value },
            ];
          } else {
            serviceRequestTagging = [
              ...serviceRequestTagging,
              { id: tag.value },
            ];
          }
        })
      );
    }

    let serviceRequestObj = easyWalkThroughFormData.serviceRequestObj;
    let params = {
      id: serviceRequestObj.id,
      subject: easyWalkThroughFormData.subject,
      description: easyWalkThroughFormData.description,
      issueType: easyWalkThroughFormData.issueType,
      issueTypeId: easyWalkThroughFormData.issueTypeId,
      creatorId: user.id,
      tags: serviceRequestTagging,
    };
    if (theme === 'Formwerks') {
      if (
        easyWalkThroughFormData.selectedImage &&
        easyWalkThroughFormData.selectedImage.length > 0
      ) {
        let showUploadMessage = easyWalkThroughFormData.selectedImage.filter(
          (img) => img && img.preview
        );
        if (showUploadMessage && showUploadMessage.length > 0) {
          toast.info('ⓘ  Please wait, while the file is being uploaded.', {
            autoClose: 4000,
            position: 'top-center',
          });
        }
        this.props.startFormLoading();
        await this.handleMultipleUpload(
          easyWalkThroughFormData.selectedImage,
          function (resObj) {
            params.Attachment = JSON.stringify(resObj).toString();
            onUpdateServiceRequest(params, 'offline');
          }
        );
      } else {
        params.profileImage = '';
        params.Attachment = '';
        onUpdateServiceRequest(params, 'offline');
      }
    } else {
      params.Attachment =
        easyWalkThroughFormData.selectedImage &&
        easyWalkThroughFormData.selectedImage.length > 0
          ? JSON.stringify(easyWalkThroughFormData.selectedImage).toString()
          : '';
      onUpdateServiceRequest(params, 'offline');
    }
    this.setState({ editInprogress: false });

    onSetEasyWalkThroughFormData({
      serviceRequestId: null,
      description: '',
      assetId: null,
      subAreas: [],
      selectedImage: '',
      areaId: '',
      areaName: '',
      serviceRequestObj: {},
      tags: [],
    });
    this.setDefaultIssueType();
  };
  deleteServiceRequest = (data) => {
    this.props.onDeleteServiceRequest(
      data.id,
      'walkthrough',
      data.walkthroughId
    );
  };
  editServiceRequest = async (data) => {
    this.setState({ editInprogress: true });
    const areas = this.state.locations;
    const { onSetEasyWalkThroughFormData } = this.props;
    let filteredArea;
    filteredArea = areas.filter((area) => area.areaId === data.area.id)[0];
    onSetEasyWalkThroughFormData({
      areaId: data.area.id,
      // subAreas: filteredArea && filteredArea.subAreas ? filteredArea.subAreas : []
    });
    let selectedImage;
    let convertedImages = [];
    let Attachment;
    if (data.attachment) {
      Attachment = data.attachment;
      selectedImage = JSON.parse(Attachment);
    } else {
      selectedImage = '';
    }
    let selectedTags = [];
    if (data.tags && data.tags.length > 0) {
      data.tags.map((tag) => {
        selectedTags = [...selectedTags, { value: tag.id, label: tag.name }];
      });
    }
    this.onFetchAssetsByLocationId(data.area.id, data.walkthroughId);
    this.props.onSetEasyWalkThroughFormData({
      serviceRequestObj: data,
      serviceRequestId: data.id,
      assetId:
        data.asset && data.asset.id
          ? data.asset.id
          : data.assets && data.assets.id
            ? data.assets.id
            : data.assetId,
      description: data.description,
      selectedImage:
        selectedImage && selectedImage.length > 0 ? selectedImage : '',
      issueType:
        data.issueType && data.issueType.name
          ? data.issueType.name
          : data.issueType,
      issueTypeId:
        data.issueType && data.issueType.id
          ? data.issueType.id
          : data.issueTypeId,
      tags: selectedTags,
    });
  };

  signatures() {
    const { walkThroughSignatureList } = this.state;
    let signatures =
      walkThroughSignatureList && walkThroughSignatureList.length > 0
        ? walkThroughSignatureList
        : [];
    let mandatorySigns = [];
    mandatorySigns = [...signatures, ...[{ button: 'Add Signee' }]];
    return mandatorySigns;
  }

  handleSignature(image, signType, index, data, type) {
    const { firstName, lastName, role, email, walkThroughSignatureList } =
      this.state;
    let signatures =
      walkThroughSignatureList && walkThroughSignatureList.length > 0
        ? walkThroughSignatureList
        : [];
    let obj = {};
    if (image !== null) {
      if (type && type === 'AddNewSignee') {
        obj = {
          email,
          firstName,
          lastName,
          role,
          signType,
          signature: image,
        };
        this.setState({
          firstName: '',
          lastName: '',
          role: '',
          email: '',
          showAddForm: false,
        });
      } else {
        obj = data;

        obj = {
          ...obj,
          signature: image,
          signType: signType,
        };
      }
      let signs = [];
      if (signatures.length > 0) {
        let objExists = signatures[index] ? true : false;
        if (objExists === true) {
          signs = signatures.map((data, i) => {
            if (i === index) {
              return obj;
            } else {
              return data;
            }
          });
        } else {
          signs = [...signatures, ...[obj]];
        }
      } else {
        signs = [obj];
      }

      this.setState({ walkThroughSignatureList: signs });
    } else {
      toast.error('🚫 Please enter a valid signature.', {
        autoClose: 10000,
        position: 'top-center',
      });
    }
  }

  disableButton() {
    const { walkThroughSignatureList } = this.state;
    let signatures =
      walkThroughSignatureList && walkThroughSignatureList.length > 0
        ? walkThroughSignatureList
        : [];
    if (signatures.length > 0) {
      let disable = false;
      signatures.map((sign) => {
        if (sign.signature === null || sign.signature === '') {
          disable = true;
        }
      });

      return disable;
    } else {
      return true;
    }
  }

  removeSignature(data, index) {
    const { walkThroughSignatureList } = this.state;
    let signs = [];
    for (let i = 0; i < walkThroughSignatureList.length; i++) {
      if (i === index) {
      } else {
        signs = [...signs, walkThroughSignatureList[i]];
      }
    }
    this.setState({ walkThroughSignatureList: signs });
  }

  checkAttachment(data) {
    if (data && data.attachment) {
      let attachment = data.attachment.split('/');
      return attachment.length > 0 ? true : false;
    } else {
      return false;
    }
  }

  async showImages(data) {
    let selectedImage;
    if (data && data.attachment) {
      selectedImage = JSON.parse(data.attachment);
      this.setState({
        selectedImages: selectedImage,
        showImages: true,
        selectedIndex: 0,
      });
    }
  }

  displayImages() {
    const { showImages, selectedImages, selectedIndex } = this.state;

    return (
      <ReusableLightbox
        isOpen={showImages}
        onClose={() => this.setState({ showImages: false })}
        images={selectedImages}
        initialIndex={selectedIndex}
        onIndexChange={(index) => this.setState({ selectedIndex: index })}
      />
    );
  }

  issueCountByArea() {
    const { easyWalkThroughFormData } = this.props;
    let serviceRequests =
      easyWalkThroughFormData.walkThroughServiceRequests &&
      easyWalkThroughFormData.walkThroughServiceRequests.length > 0
        ? easyWalkThroughFormData.walkThroughServiceRequests
        : [];
    if (serviceRequests.length > 0) {
    }
    return 10;
  }

  areaAssetServiceRequests(serviceRequests) {
    const { easyWalkThroughFormData } = this.props;
    let areaId = easyWalkThroughFormData.areaId;
    let assetId = easyWalkThroughFormData.assetId;
    let temp = [];
    if (serviceRequests && serviceRequests.length > 0) {
      if (easyWalkThroughFormData.areaId && easyWalkThroughFormData.assetId) {
        for (var i = 0; i < serviceRequests.length; i++) {
          if (
            (serviceRequests[i].areaId
              ? serviceRequests[i].areaId === areaId
              : serviceRequests[i].area.id === areaId) &&
            (serviceRequests[i].assetId
              ? serviceRequests[i].assetId === assetId
              : serviceRequests[i].assets.id === assetId)
          ) {
            temp.push(serviceRequests[i]);
          }
        }
      }
      return temp;
    } else {
      return [];
    }
  }

  getServiceRequestCountByArea(areaId) {
    const { easyWalkThroughFormData } = this.props;
    let serviceRequests = easyWalkThroughFormData.walkThroughServiceRequests;
    let temp = [];
    if (serviceRequests && serviceRequests.length > 0) {
      for (var i = 0; i < serviceRequests.length; i++) {
        if (serviceRequests[i].area.id === areaId) {
          temp.push(serviceRequests[i]);
        }
      }
      if (temp.length > 0) {
        if (temp.length === 1) {
          return temp.length + ' Issue';
        } else {
          return temp.length + ' Issues';
        }
      } else {
        return 'No Issues';
      }
    } else {
      return 'No Issues';
    }
  }

  checkForImages(images) {
    return images;
  }

  // function to set the selected tags
  setTags = (newValue, actionMeta) => {
    const { onSetEasyWalkThroughFormData } = this.props;
    onSetEasyWalkThroughFormData({
      tags: newValue,
    });
  };

  render() {
    const {
      propertyWalkThroughFormData,
      easyWalkThroughFormData,
      loader,
      types,
      onSetEasyWalkThroughFormData,
      serviceRequestTags,
    } = this.props;
    let serviceRequests = easyWalkThroughFormData.walkThroughServiceRequests;
    let signatures = this.signatures();
    const {
      firstName,
      lastName,
      role,
      email,
      showAddForm,
      reviewAndSignIn,
      subAreasByLocation,
      locations,
    } = this.state;
    let areaAssetServiceRequests =
      this.areaAssetServiceRequests(serviceRequests);

    return (
      <div>
        {loader ? <Loader center={true} /> : null}

        <div className="offlineWalkthroughData">
          {propertyWalkThroughFormData.status === 'Review' ? null : (
            <CreateDeveloperServiceRequest
              subAreasByLocation={this.state.subAreasByLocation}
              locations={this.state.locations}
              easyWalkThroughFormData={easyWalkThroughFormData}
              onSetEasyWalkThroughFormData={onSetEasyWalkThroughFormData}
              // areas={areas}
              types={types}
              onSelectIssueType={this.onSelectIssueType}
              handleDelete={this.handleDelete}
              onSelectImage={this.onSelectImage}
              updateServiceRequest={this.updateServiceRequest}
              onChange={this.onChange}
              onCreateServiceRequest={this.onCreateServiceRequest}
              walkthroughId={propertyWalkThroughFormData.walkthroughId}
            />
          )}

          <div className="offlineWalkthroughData__listView">
            {serviceRequests && serviceRequests.length > 0 ? (
              <ReviewTable1
                columns={[
                  {
                    xsHide: true,
                    label: 'Location',
                    cell: (data) =>
                      data.area && data.area.name
                        ? data.area.name
                        : data.areaName
                          ? data.areaName
                          : '',
                  },
                  {
                    xsHide: true,
                    label: 'Item',
                    cell: (data) => {
                      return data && data.itemName
                        ? data.itemName
                        : data &&
                            data.asset &&
                            data.asset.item &&
                            data.asset.item.name
                          ? data.asset.item.name
                          : '';
                    },
                  },
                  {
                    xsHide: true,
                    label: 'Issue Type',
                    cell: (data) =>
                      data.serviceType
                        ? data.serviceType
                        : data.issueType && data.issueType.name
                          ? data.issueType.name
                          : data.issueType
                            ? data.issueType
                            : '',
                  },
                  {
                    label: 'Description',
                    cell: (data) => data.description,
                  },
                  {
                    label: <FontAwesomeIcon glyph="paperclip" weight="light" />,
                    cell: (data) => (
                      <>
                        {this.checkAttachment(data) ? (
                          <div onClick={() => this.showImages(data)}>
                            <Avatar
                              badge={
                                JSON.parse(data.attachment).length > 1
                                  ? 'count'
                                  : ''
                              }
                              url={JSON.parse(data.attachment)[0]}
                            />
                          </div>
                        ) : null}
                      </>
                    ),
                  },
                  propertyWalkThroughFormData.status === 'Review'
                    ? ''
                    : {
                        label: '',
                        cell: (data) => (
                          <>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <div
                                style={{ display: 'flex', cursor: 'pointer' }}
                                onClick={() => this.editServiceRequest(data)}
                              >
                                <FontAwesomeIcon glyph="pencil" weight="light" />
                              </div>

                              <div
                                style={{ marginLeft: 20, cursor: 'pointer' }}
                                onClick={() =>
                                  this.state.editInprogress === true
                                    ? alert(
                                        'a edit is in progress please update and then perform delete operation'
                                      )
                                    : window.confirm(
                                        `Are you sure you want to delete ${data.ticketId ? data.ticketId : data.dummyId}?`
                                      ) && this.deleteServiceRequest(data)
                                }
                              >
                                <FontAwesomeIcon glyph="trash" weight="light" />
                              </div>
                            </div>
                          </>
                        ),
                      },
                ]}
                data={serviceRequests}
              />
            ) : null}
          </div>
          <div style={{ marginTop: 20 }}>
            <Textarea
              value={
                propertyWalkThroughFormData.status === 'Review'
                  ? propertyWalkThroughFormData.configTypeSaved &&
                    propertyWalkThroughFormData.configTypeSaved.notes
                    ? propertyWalkThroughFormData.configTypeSaved.notes
                    : ''
                  : easyWalkThroughFormData.notes
              }
              onChange={(e) =>
                onSetEasyWalkThroughFormData({ notes: e.target.value })
              }
              label="Notes"
              placeholder="Notes"
              disabled={propertyWalkThroughFormData.status === 'Review'}
              block
            />
          </div>
          {reviewAndSignIn ? null : propertyWalkThroughFormData.status ===
            'Review' ? null : (
            <div className="offlineWalkthroughData__review">
              <Col md={3} xs={4}>
                <Button
                  color="complete_purple"
                  label="Review & Sign"
                  onClick={() => this.setState({ showCompleteOverlay: true })}
                  size="small"
                  disabled={false}
                  block
                />
              </Col>
            </div>
          )}
          {reviewAndSignIn ? (
            <div style={{ marginTop: 20 }}>
              <Row>
                {signatures && signatures.length > 0
                  ? signatures.map((data, index) =>
                      data.button === 'Add Signee' ? (
                        <>
                          <Col xs="12" md="6">
                            {showAddForm ? (
                              <div>
                                <div
                                  style={{ paddingLeft: 40, paddingRight: 40 }}
                                >
                                  <Row>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={firstName}
                                        onChange={(e) =>
                                          this.setState({
                                            firstName: e.target.value,
                                          })
                                        }
                                        placeholder="First Name"
                                        block
                                      />
                                    </Col>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={lastName}
                                        onChange={(e) =>
                                          this.setState({
                                            lastName: e.target.value,
                                          })
                                        }
                                        placeholder="Last Name"
                                        block
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={role}
                                        onChange={(e) =>
                                          this.setState({
                                            role: e.target.value,
                                          })
                                        }
                                        placeholder="Role"
                                        block
                                      />
                                    </Col>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={email}
                                        onChange={(e) =>
                                          this.setState({
                                            email: e.target.value,
                                          })
                                        }
                                        placeholder="Email Address"
                                        block
                                      />
                                    </Col>
                                  </Row>
                                </div>
                                <SignatureCanvas
                                  onInsert={(url, signType) => {
                                    this.setState({ showOverlay: false });
                                    this.handleSignature(
                                      url,
                                      signType,
                                      index,
                                      null,
                                      'AddNewSignee'
                                    );
                                  }}
                                  firstName={firstName ? firstName : ''}
                                  lastName={lastName ? lastName : ''}
                                  signed=""
                                  signType={1}
                                  typeOfSign={
                                    propertyWalkThroughFormData.walkthroughType
                                  }
                                  permissions={
                                    propertyWalkThroughFormData.permissions
                                      ? propertyWalkThroughFormData.permissions
                                      : ''
                                  }
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  color: '#00848E',
                                  display: 'flex',
                                  height: '35vh',
                                  backgroundColor: 'rgba(214, 207, 207, 0.1)',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginTop: 40,
                                }}
                                onClick={() =>
                                  this.setState({ showAddForm: true })
                                }
                              >
                                <div style={{ paddingRight: 3 }}>
                                  <FontAwesomeIcon glyph="plus-circle" weight="regular" />
                                </div>
                                <div style={{ fontWeight: 600 }}>
                                  {data.button?.toUpperCase()}
                                </div>
                              </div>
                            )}
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col xs="12" md="6">
                            <Row mdCenter>
                              <Col md="8">
                                <div className="offlineWalkthroughData__signature">
                                  {data.firstName} {data.lastName} {data.role}{' '}
                                  Signature
                                </div>
                              </Col>
                            </Row>

                            <SignatureCanvas
                              onInsert={(url, signType) => {
                                this.handleSignature(
                                  url,
                                  signType,
                                  index,
                                  data
                                );
                              }}
                              signed={
                                data.signature !== '' || data.signature !== null
                                  ? data.signature
                                  : ''
                              }
                              signType={data.signType}
                              remove={() => this.removeSignature(data, index)}
                              firstName={data.firstName ? data.firstName : ''}
                              lastName={data.lastName ? data.lastName : ''}
                              typeOfSign={
                                propertyWalkThroughFormData.walkthroughType
                              }
                              permissions={
                                propertyWalkThroughFormData.permissions
                                  ? propertyWalkThroughFormData.permissions
                                  : ''
                              }
                            />
                          </Col>
                        </>
                      )
                    )
                  : null}
              </Row>
              <div
                style={{
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  display: 'flex',
                  paddingTop: 10,
                }}
              >
                <Col md={3} xs={4}>
                  <Button
                    color={this.disableButton() ? 'grey' : 'complete_purple'}
                    label="Complete Walk Through"
                    onClick={() => this.handleSubmit()}
                    size="small"
                    disabled={this.disableButton()}
                    block
                  />
                </Col>
              </div>
            </div>
          ) : null}
        </div>
        <Overlay
          showOverlay={this.state.showOverlay}
          content={
            <Marker
              onClose={() => this.setState({ showOverlay: false })}
              images={this.props.easyWalkThroughFormData.selectedImage}
              onSaveImagesAnotated={(images) => {
                this.onSaveImagesAnotated(images);
                this.setState({ showOverlay: false });
              }}
            />
          }
        />
        <Overlay
          showOverlay={this.state.showCompleteOverlay}
          content={
            <CompleteDeveloperWalkThrough
              headline="Walk Through Review & Confirmation"
              strapline={
                <div
                  style={{
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: 20,
                  }}
                >
                  <div style={{ color: '#00848E', paddingRight: 3 }}>
                    <FontAwesomeIcon glyph="check-circle" size="medium" weight="regular" />
                  </div>
                  <div style={{ color: '#00848E', paddingRight: 3 }}>
                    {' '}
                    {easyWalkThroughFormData.walkThroughServiceRequests &&
                    easyWalkThroughFormData.walkThroughServiceRequests.length >
                      0
                      ? easyWalkThroughFormData.walkThroughServiceRequests
                          .length
                      : '0'}{' '}
                    issues logged
                  </div>
                </div>
              }
              onClose={() => this.setState({ showCompleteOverlay: false })}
              handleDelete={this.handleDelete}
              onSelectImage={this.onSelectImage}
              updateServiceRequest={this.updateServiceRequest}
              editServiceRequest={this.editServiceRequest}
              handleCompleteWalkThrough={(signatures) =>
                this.handleCompleteWalkThrough(signatures)
              }
              deleteServiceRequest={this.deleteServiceRequest}
              subAreasByLocation={this.state.subAreasByLocation}
              locations={this.state.locations}
            />
          }
        />

        {this.state.showImages === true ? <>{this.displayImages()}</> : null}
        <div className="simplifiedMobileWalkThrough">
          <div style={{ marginTop: 20 }}>
            <Textarea
              value={
                propertyWalkThroughFormData.status === 'Review'
                  ? propertyWalkThroughFormData.configTypeSaved &&
                    propertyWalkThroughFormData.configTypeSaved.notes
                    ? propertyWalkThroughFormData.configTypeSaved.notes
                    : ''
                  : easyWalkThroughFormData.notes
              }
              onChange={(e) =>
                onSetEasyWalkThroughFormData({ notes: e.target.value })
              }
              label="Notes"
              placeholder="Notes"
              disabled={propertyWalkThroughFormData.status === 'Review'}
              block
            />
          </div>
          <div className="simplifiedMobileWalkThrough__suiteTitle">
            <div className="simplifiedMobileWalkThrough__suiteTitle--label">
              {propertyWalkThroughFormData.suiteName}
            </div>
          </div>
          {locations && locations.length > 0
            ? locations.map((a, i) => (
                <>
                  <div
                    className={classNames(
                      'simplifiedMobileWalkThrough__areas',
                      {
                        'simplifiedMobileWalkThrough__areas--top': i == 0,
                        'simplifiedMobileWalkThrough__areas--selected':
                          easyWalkThroughFormData.areaId === a.areaId,
                      }
                    )}
                    onClick={() =>
                      easyWalkThroughFormData.areaId === a.areaId
                        ? onSetEasyWalkThroughFormData({ areaId: '' })
                        : this.onChange({ target: { value: a.areaId } })
                    }
                  >
                    <div className="simplifiedMobileWalkThrough__areas--title">
                      <div
                        style={{ display: 'flex' }}
                        className={classNames(
                          'simplifiedMobileWalkThrough__areas--label',
                          {
                            'simplifiedMobileWalkThrough__areas--label--selected':
                              easyWalkThroughFormData.areaId === a.areaId,
                          }
                        )}
                      >
                        <div className="simplifiedMobileWalkThrough__areas--circle">
                          <div
                            style={{
                              padding: 10,
                              marginLeft: 1,
                              color: '#00848E',
                            }}
                          >
                            <FontAwesomeIcon glyph="door-open" weight="light" />
                          </div>
                        </div>
                        {a.customLabel ? a.customLabel : a.name}
                      </div>
                      <div
                        className={classNames(
                          'simplifiedMobileWalkThrough__areas--issueDropDown',
                          {
                            'simplifiedMobileWalkThrough__areas--issueDropDown--selected':
                              easyWalkThroughFormData.areaId === a.areaId,
                          }
                        )}
                      >
                        {this.getServiceRequestCountByArea(a.areaId)}{' '}
                        <FontAwesomeIcon glyph="caret-down" weight="solid" />
                      </div>
                    </div>
                  </div>

                  {easyWalkThroughFormData.areaId === a.areaId &&
                  subAreasByLocation &&
                  subAreasByLocation.length > 0
                    ? subAreasByLocation.map((s, i) => (
                        <div className="simplifiedMobileWalkThrough__assets">
                          <div
                            className="simplifiedMobileWalkThrough__assets--title"
                            onClick={() =>
                              onSetEasyWalkThroughFormData({
                                assetId: s.assetId,
                              })
                            }
                          >
                            <div className="simplifiedMobileWalkThrough__assets--label">
                              <div className="simplifiedMobileWalkThrough__assets--circle">
                                <div
                                  style={{
                                    padding: 10,
                                    marginLeft: 1,
                                    color: '#00848E',
                                  }}
                                >
                                  <FontAwesomeIcon glyph="inventory" weight="light" />
                                </div>
                              </div>{' '}
                              {s.name}
                            </div>
                            <div
                              className="simplifiedMobileWalkThrough__assets--issueDropDown"
                              onClick={() =>
                                onSetEasyWalkThroughFormData({
                                  addServiceRequest: true,
                                })
                              }
                            >
                              <div className="simplifiedMobileWalkThrough__assets--issueDropDown--circle">
                                {' '}
                                <div
                                  style={{
                                    padding: 9,
                                    marginLeft: 2,
                                    color: 'white',
                                  }}
                                >
                                  <FontAwesomeIcon glyph="plus" weight="solid" />
                                </div>
                              </div>
                            </div>
                          </div>
                          {easyWalkThroughFormData.addServiceRequest &&
                          easyWalkThroughFormData.addServiceRequest === true &&
                          s.assetId === easyWalkThroughFormData.assetId ? (
                            <>
                              <div
                                className={classNames(
                                  'simplifiedMobileWalkThrough__assets--serviceRequest',
                                  {
                                    'simplifiedMobileWalkThrough__assets--serviceRequest--hide':
                                      propertyWalkThroughFormData.status ===
                                      'Review',
                                  }
                                )}
                              >
                                <div style={{ height: 40, display: 'flex' }}>
                                  <CustomSelect
                                    simplifiedMobileWalkThrough={true}
                                    placeholder="Select issue type"
                                    onChange={(e) => this.onSelectIssueType(e)}
                                    value={
                                      easyWalkThroughFormData &&
                                      easyWalkThroughFormData.issueTypeId
                                        ? easyWalkThroughFormData.issueTypeId
                                        : ''
                                    }
                                    options={
                                      types && types.length > 0
                                        ? types.map((t) => ({
                                            id: t.id,
                                            name: t.name,
                                          }))
                                        : []
                                    }
                                    disabled={
                                      easyWalkThroughFormData.serviceRequestId
                                    }
                                  />
                                </div>

                                <div
                                  className="offlineWalkthroughData__selectItem"
                                  style={{ marginTop: 20, width: '100%' }}
                                >
                                  <div
                                    className="offlineWalkthroughData__item"
                                    style={{
                                      alignItems: 'center',
                                      height: 30,
                                      border: 0,
                                      textAlign: 'right',
                                    }}
                                  >
                                    {easyWalkThroughFormData &&
                                    easyWalkThroughFormData.selectedImage &&
                                    easyWalkThroughFormData.selectedImage
                                      .length > 0 ? (
                                      easyWalkThroughFormData.selectedImage.map(
                                        (image) => {
                                          return easyWalkThroughFormData
                                            .selectedImage.length > 1 ? (
                                            <div
                                              style={{
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                position: 'relative',
                                              }}
                                            >
                                              <img
                                                alt=""
                                                src={image}
                                                style={{
                                                  width: 40,
                                                  height: 25,
                                                  paddingLeft: 10,
                                                  paddingTop: 5,
                                                }}
                                              />
                                              <div
                                                className="offlineWalkthroughData__delete"
                                                onClick={() =>
                                                  this.handleDelete(image)
                                                }
                                              >
                                                <i class="far fa-trash-alt"></i>
                                              </div>
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                              }}
                                            >
                                              <div
                                                style={{
                                                  width: 40,
                                                  height: 37,
                                                  paddingRight: 10,
                                                  position: 'relative',
                                                }}
                                              >
                                                <img
                                                  alt=""
                                                  src={image}
                                                  style={{
                                                    width: 40,
                                                    height: 25,
                                                    paddingTop: 5,
                                                  }}
                                                />
                                                <div
                                                  className="offlineWalkthroughData__delete"
                                                  style={{ right: 10 }}
                                                  onClick={() =>
                                                    this.handleDelete(image)
                                                  }
                                                >
                                                  <i class="far fa-trash-alt"></i>
                                                </div>
                                              </div>

                                              <File
                                                onSelect={(file) =>
                                                  onCheckDocument(file) &&
                                                  this.onSelectImage(file)
                                                }
                                                files={[]}
                                                smallIcon={true}
                                                multiSelect={true}
                                                type="image"
                                              />
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <File
                                        onSelect={(file) =>
                                          onCheckDocument(file) &&
                                          this.onSelectImage(file)
                                        }
                                        files={[]}
                                        smallIcon={true}
                                        multiSelect={true}
                                        type="image"
                                      />
                                    )}
                                    <div
                                      style={{
                                        backgroundColor: 'grey',
                                        marginLeft: 10,
                                        padding: 2,
                                        borderRadius: 2,
                                        textAlign: 'right',
                                      }}
                                      onClick={() =>
                                        easyWalkThroughFormData.selectedImage
                                          .length > 1
                                          ? alert('Reached max uploads')
                                          : null
                                      }
                                    >
                                      Upload Images
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="offlineWalkthroughData__selectItem"
                                  style={{ marginTop: 20 }}
                                >
                                  <input
                                    style={{ padding: 10, border: 1 }}
                                    className="offlineWalkthroughData__selectItem"
                                    onChange={(e) =>
                                      onSetEasyWalkThroughFormData({
                                        description: e.target.value,
                                      })
                                    }
                                    placeholder="Add Description"
                                    value={easyWalkThroughFormData.description}
                                  />
                                </div>
                                <div
                                  className="offlineWalkthroughData__selectItem"
                                  style={{ marginTop: 20, display: 'block' }}
                                >
                                  <Row>
                                    <Col xs={12}>
                                      <CreatableSelect
                                        placeholder="Add or create tags"
                                        closeMenuOnSelect={false}
                                        isClearable
                                        isMulti
                                        options={
                                          serviceRequestTags.length > 0
                                            ? serviceRequestTags.map(
                                                (item) => ({
                                                  value: item.id,
                                                  label: item.name,
                                                })
                                              )
                                            : []
                                        }
                                        value={
                                          easyWalkThroughFormData.tags
                                            ? easyWalkThroughFormData.tags
                                            : []
                                        }
                                        onChange={(newValue, actionMeta) =>
                                          this.setTags(newValue, actionMeta)
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </div>
                                <div
                                  className="offlineWalkthroughData__item"
                                  style={{ borderRight: 0, marginTop: 20 }}
                                >
                                  <Button
                                    color={
                                      !easyWalkThroughFormData.areaId ||
                                      !easyWalkThroughFormData.assetId ||
                                      !easyWalkThroughFormData.issueTypeId ||
                                      !easyWalkThroughFormData.description
                                        ? 'grey'
                                        : 'teal'
                                    }
                                    label={
                                      easyWalkThroughFormData.serviceRequestId
                                        ? 'UPDATE'
                                        : 'Save'
                                    }
                                    onClick={() => {
                                      easyWalkThroughFormData.serviceRequestId
                                        ? this.updateServiceRequest()
                                        : this.onCreateServiceRequest();
                                    }}
                                    size="small"
                                    disabled={
                                      !easyWalkThroughFormData.areaId ||
                                      !easyWalkThroughFormData.assetId ||
                                      !easyWalkThroughFormData.issueTypeId ||
                                      !easyWalkThroughFormData.description
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          ) : null}
                          {s.assetId === easyWalkThroughFormData.assetId ? (
                            <div style={{ padding: 20, marginLeft: 30 }}>
                              {areaAssetServiceRequests &&
                              areaAssetServiceRequests.length > 0 ? (
                                <ReviewTable1
                                  simplifiedMobileWalkThrough={true}
                                  columns={[
                                    {
                                      label: 'Issue Type',
                                      cell: (data) =>
                                        data.serviceType
                                          ? data.serviceType ===
                                            'Heating/Cooling'
                                            ? 'Heating/ Cooling'
                                            : data.serviceType
                                          : data.issueType &&
                                              data.issueType.name
                                            ? data.issueType.name ===
                                              'Heating/Cooling'
                                              ? 'Heating/ Cooling'
                                              : data.issueType.name
                                            : data.issueType
                                              ? data.issueType ===
                                                'Heating/Cooling'
                                                ? 'Heating/ Cooling'
                                                : data.issueType
                                              : '',
                                    },
                                    {
                                      // center:true,
                                      label: 'Description',
                                      cell: (data) => data.description,
                                    },
                                    {
                                      center: true,
                                      label: (
                                        <FontAwesomeIcon
                                          glyph="paperclip"
                                          weight="light"
                                        />
                                      ),
                                      cell: (data) => (
                                        <>
                                          {this.checkAttachment(data) ? (
                                            <div
                                              onClick={() =>
                                                this.showImages(data)
                                              }
                                            >
                                              <FontAwesomeIcon
                                                glyph="file"
                                                weight="light"
                                              />
                                            </div>
                                          ) : null}
                                        </>
                                      ),
                                    },
                                  ]}
                                  data={areaAssetServiceRequests}
                                />
                              ) : null}
                            </div>
                          ) : null}
                        </div>
                      ))
                    : null}
                </>
              ))
            : null}
          {reviewAndSignIn ? null : propertyWalkThroughFormData.status ===
            'Review' ? null : (
            <div className="offlineWalkthroughData__review">
              <Col md={3} xs={8}>
                <Button
                  color="complete_purple"
                  label="Review & Sign"
                  onClick={() => this.setState({ showCompleteOverlay: true })}
                  size="small"
                  disabled={false}
                  block
                />
              </Col>
            </div>
          )}
          {reviewAndSignIn ? (
            <div style={{ marginTop: 20 }}>
              <Row>
                {signatures && signatures.length > 0
                  ? signatures.map((data, index) =>
                      data.button === 'Add Signee' ? (
                        <>
                          <Col xs="12" md="6">
                            {showAddForm ? (
                              <div>
                                <div
                                  style={{ paddingLeft: 40, paddingRight: 40 }}
                                >
                                  <Row>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={firstName}
                                        onChange={(e) =>
                                          this.setState({
                                            firstName: e.target.value,
                                          })
                                        }
                                        placeholder="First Name"
                                        block
                                      />
                                    </Col>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={lastName}
                                        onChange={(e) =>
                                          this.setState({
                                            lastName: e.target.value,
                                          })
                                        }
                                        placeholder="Last Name"
                                        block
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={role}
                                        onChange={(e) =>
                                          this.setState({
                                            role: e.target.value,
                                          })
                                        }
                                        placeholder="Role"
                                        block
                                      />
                                    </Col>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={email}
                                        onChange={(e) =>
                                          this.setState({
                                            email: e.target.value,
                                          })
                                        }
                                        placeholder="Email Address"
                                        block
                                      />
                                    </Col>
                                  </Row>
                                </div>
                                <SignatureCanvas
                                  onInsert={(url, signType) => {
                                    this.setState({ showOverlay: false });
                                    this.handleSignature(
                                      url,
                                      signType,
                                      index,
                                      null,
                                      'AddNewSignee'
                                    );
                                  }}
                                  firstName={firstName ? firstName : ''}
                                  lastName={lastName ? lastName : ''}
                                  signed=""
                                  signType={1}
                                  typeOfSign={
                                    propertyWalkThroughFormData.walkthroughType
                                  }
                                  permissions={
                                    propertyWalkThroughFormData.permissions
                                      ? propertyWalkThroughFormData.permissions
                                      : ''
                                  }
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  color: '#00848E',
                                  display: 'flex',
                                  height: '35vh',
                                  backgroundColor: 'rgba(214, 207, 207, 0.1)',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginTop: 40,
                                }}
                                onClick={() =>
                                  this.setState({ showAddForm: true })
                                }
                              >
                                <div style={{ paddingRight: 3 }}>
                                  <FontAwesomeIcon glyph="plus-circle" weight="regular" />
                                </div>
                                <div style={{ fontWeight: 600 }}>
                                  {data.button?.toUpperCase()}
                                </div>
                              </div>
                            )}
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col xs="12" md="6">
                            <Row mdCenter>
                              <Col md="8">
                                <div className="offlineWalkthroughData__signature">
                                  {data.firstName} {data.lastName} {data.role}{' '}
                                  Signature
                                </div>
                              </Col>
                            </Row>

                            <SignatureCanvas
                              onInsert={(url, signType) => {
                                this.handleSignature(
                                  url,
                                  signType,
                                  index,
                                  data
                                );
                              }}
                              signed={
                                data.signature !== '' || data.signature !== null
                                  ? data.signature
                                  : ''
                              }
                              signType={data.signType}
                              remove={() => this.removeSignature(data, index)}
                              firstName={data.firstName ? data.firstName : ''}
                              lastName={data.lastName ? data.lastName : ''}
                              typeOfSign={
                                propertyWalkThroughFormData.walkthroughType
                              }
                              permissions={
                                propertyWalkThroughFormData.permissions
                                  ? propertyWalkThroughFormData.permissions
                                  : ''
                              }
                            />
                          </Col>
                        </>
                      )
                    )
                  : null}
              </Row>
              <div
                style={{
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  display: 'flex',
                  paddingTop: 10,
                }}
              >
                <Col md={3} xs={4}>
                  <Button
                    color={this.disableButton() ? 'grey' : 'complete_purple'}
                    label="Complete Walk Through"
                    onClick={() => this.handleSubmit()}
                    size="small"
                    disabled={this.disableButton()}
                    block
                  />
                </Col>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let propertyWalkThroughFormData = selectPropertyWalkThroughFormData(state);
  let suite = selectSuiteById(state, propertyWalkThroughFormData.suiteId);
  return {
    suite,
    propertyWalkThroughFormData,
    user: selectAuthenticatedUser(state),
    ticketStatus: state.formOptions.ticketStatus,
    areas: state.areas,
    loader: selectFormLoader(state),
    suiteWalkthrough: selectWalkThrough(state),
    easyWalkThroughFormData: selectEasyWalkThroughFormData(state),
    types: state.formOptions.types,
    serviceRequestTags: state.formOptions.serviceRequestTags,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSetEasyWlkThroughFormNextStep: setEasyWalkThroughFormNextStep,
      onFetchAreasAndSubAreas: fetchAreasAndSubAreas,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,
      onFetchAreaData: fetchAreaData,
      onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,
      startFormLoading,
      stopFormLoading,
      onFetchTicketStatus: fetchAllTicketStatus,

      onSetPropertyWalkThroughFormStep: setPropertyWalkThroughFormStep,

      onFetchSuiteCheckList: fetchSuiteCheckList,
      onFetchConfigureTypeWalkThroughData: fetchConfigureTypeWalkThroughData,
      setWalkThroughStatus: setWalkThroughStatus,
      onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
      onFetchWalkThroughServiceList: fetchWalkThroughServiceList,
      onExitEasyWalkThroughForm: exitEasyWalkThroughForm,

      onSaveServiceRequest: saveServiceRequest,
      onDeleteServiceRequest: deleteServiceRequest,
      onUpdateServiceRequest: updateServiceRequest,
      onFetchServiceRequestTags: fetchServiceRequestTags,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeveloperWalkthrough);
